import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import translate from '../../../../commonComponents/translate';
import CurrencyProp from '../../../profile/propTypes/currencyProp';
import FastBonusCard from './FastBonusCard';

const FastStartBonus = props => {
  const { t, data, dateData } = props;

  if (!data) return null;

  return (
    <div className="fast-start-bonus">
      <div className="fast-start-bonus-header">
        <div className="career-section-title">
          {t('report.neofin.fastStartBonus')}
        </div>
        <div className="career-section-subtitle">
          {`${t('report.neofin.fastStartBonus.collaboratorSince')}  ${moment(
            dateData,
          ).format('DD/MM/YYYY')}`}
        </div>
      </div>
      <div className="fast-start-bonus-content">
        {data.map((bonusData, index) => (
          <FastBonusCard
            key={index}
            t={t}
            index={index}
            bonusData={bonusData}
          />
        ))}
      </div>
    </div>
  );
};

FastStartBonus.propTypes = {
  t: PropTypes.func.isRequired,
  dateData: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      bonusType: PropTypes.string,
      numDays: PropTypes.number,
      daysRemaining: PropTypes.number,
      skillLevelName: PropTypes.string,
      objectiveLevel: PropTypes.number,
      commission: PropTypes.number,
      bonusAchieved: PropTypes.bool,
      currencyInfo: PropTypes.shape(CurrencyProp.propType),
    }),
  ).isRequired,
};

export default translate(FastStartBonus);
